import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import Button from "@/shared/form/button";
import Text from "@/shared/typography/text";
import { Modal, useModal } from "@/shared/modal";
import { Suspense } from "@/shared/suspense";
import { McpConnection } from "@/modules/ai/widgets/mcp-connection";
import { AssistantAbilities } from "@/modules/ai/features/ask-ai-assistant/views/assistant-abilities";

/**
 * Подсказка про ассистента и адрес MCP-сервера — здесь, а не в настройках системы: подключить
 * своего агента может любой сотрудник, а в настройки попадают только администраторы.
 */
export function AssistantInfo() {
  const t = useTranslations("AI");
  const { openModal, open, close } = useModal();

  return (
    <>
      <Button
        type={"text"}
        icon={<InfoCircleOutlined />}
        onClick={open}
        title={t("About assistant")}
      />

      <Modal
        title={t("About assistant")}
        open={openModal}
        onCancel={close}
        width={640}
      >
        <div className={"grid gap-6"}>
          <AssistantAbilities />

          <div className={"grid gap-3"}>
            <Text as={"h4"} type={"subtitle1"} weight={"500"}>
              {t("EFFICA_MCP_TITLE")}
            </Text>

            <Text type={"body2"}>{t("EFFICA_MCP_DESCRIPTION")}</Text>

            <Suspense>
              <McpConnection />
            </Suspense>
          </div>
        </div>
      </Modal>
    </>
  );
}
